import { jsx as _jsx } from "react/jsx-runtime";
export default function BottomUpModalWrapper(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: "absolute top-0 left-0 z-[1000] h-full w-full bg-[#00000090] ".concat(className),
    onClick: onClose,
    children: /*#__PURE__*/_jsx("div", {
      className: "absolute bottom-0 left-0 max-h-[80%] w-full rounded-t-2xl bg-white p-6 pb-10",
      children: children
    })
  });
}